import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Locations', href: '/locations' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0A0A0A] border-b border-white/10' : 'bg-gradient-to-b from-black/70 via-black/40 to-transparent backdrop-blur-sm'}`}>
      {/* Top utility bar */}
      <div className="border-b border-white/10 py-2">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <p className="text-xs text-gray-400 hidden sm:flex items-center gap-2">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-2-fill text-[#FF6B35] text-xs" /></span>
            South Windsor, CT &mdash; Serving All of Hartford County
          </p>
          <div className="flex items-center gap-5 ml-auto">
            <a href="tel:+18605550127" className="flex items-center gap-1.5 text-white/80 hover:text-white text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center"><i className="ri-phone-fill text-[#FF6B35] text-xs" /></span>
              (860) 555-0127
            </a>
            <span className="text-white/20 text-xs">|</span>
            <a href="mailto:info@dbngarage.com" className="text-white/50 hover:text-white/80 text-xs transition-colors cursor-pointer hidden md:block">info@dbngarage.com</a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav className={`transition-all duration-300 ${scrolled ? 'py-3' : 'py-4'}`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer group">
            <img
              src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/91a191cc62cc3c3c79208c8bc56002fa.png"
              alt="DBN Garage — One Stop Auto Enhancement Destination"
              className="h-12 w-auto object-contain"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href}
                className={`text-xs font-bold uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap ${location.pathname === link.href ? 'text-[#FF6B35]' : 'text-white/70 hover:text-white'}`}>
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a href="tel:+18605550127"
              className="flex items-center gap-2 border border-white/20 hover:border-white/50 text-white font-bold text-xs px-4 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm" /></span>
              Call Now
            </a>
            <a href="#lead-form"
              className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold text-xs px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              Book Now — Free Quote
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
            </a>
          </div>

          <button className="lg:hidden w-9 h-9 flex items-center justify-center text-white rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
            <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-4">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href}
              className="flex items-center justify-between py-3.5 text-sm font-bold uppercase tracking-widest text-white/70 hover:text-white border-b border-white/10 cursor-pointer">
              {link.label}
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line text-white/30" /></span>
            </Link>
          ))}
          <div className="flex gap-3 mt-5">
            <a href="tel:+18605550127" className="flex-1 flex items-center justify-center border border-white/20 text-white font-bold py-3 rounded-lg text-sm whitespace-nowrap cursor-pointer">Call Now</a>
            <a href="#lead-form" className="flex-1 flex items-center justify-center bg-[#FF6B35] text-white font-bold py-3 rounded-lg text-sm whitespace-nowrap cursor-pointer">Book Now</a>
          </div>
        </div>
      )}
    </header>
  );
}
